"use client";

import React from "react";
import { useRouter, useSearchParams, usePathname } from "next/navigation";

export default function Pagination({ page, pageCount, displayNumberOfPage }) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const pageChange = (event, pageNumber) => {
    event.preventDefault();

    const params = new URLSearchParams(searchParams.toString());
    params.set("page", pageNumber.toString());

    // scroll: false prevents Next.js from jumping to the top
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  };

  // Fix the start and end page calculation
  const startPage =
    Math.floor((page - 1) / displayNumberOfPage) * displayNumberOfPage + 1;
  const endPage = Math.min(startPage + displayNumberOfPage - 1, pageCount);

  return (
    <>
      {!!pageCount && pageCount > 1 && (
        <div
          id="tps-aws-results-pager"
          className="tps-aws-results-pager-wrapper"
        >
          <a
            className={`pager-navs pager-first ${
              parseInt(page) === 1 && "disabled"
            }`}
            href="#"
            onClick={(e) => pageChange(e, 1)}
            title="Go to the first page of results"
          >
            First
          </a>
          <a
            className={`pager-navs pager-prev ${
              parseInt(page) === 1 && "disabled"
            }`}
            href="#"
            onClick={(e) => pageChange(e, page - 1)}
            title="Go to the previous page of results"
          >
            Previous
          </a>
          <div className="pager-nav-items">
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
              const pageNumber = startPage + i;
              return pageNumber === parseInt(page) ? (
                <span
                  title={`You are on page ${pageNumber}`}
                  key={`page-${pageNumber}`}
                >
                  {pageNumber}
                </span>
              ) : (
                <a
                  key={`page-${pageNumber}`}
                  href="#"
                  onClick={(e) => pageChange(e, pageNumber)}
                  title={`Go to page ${pageNumber}`}
                >
                  {pageNumber}
                </a>
              );
            })}
          </div>
          <a
            className={`pager-navs pager-next ${
              parseInt(page) === pageCount && "disabled"
            }`}
            href="#"
            onClick={(e) => pageChange(e, parseInt(page) + 1)}
            title="Go to the next page of results"
          >
            Next
          </a>
          <a
            className={`pager-navs pager-last ${
              parseInt(page) === pageCount && "disabled"
            }`}
            href="#"
            onClick={(e) => pageChange(e, pageCount)}
            title="Go to the last page of results"
          >
            Last
          </a>
        </div>
      )}
    </>
  );
}
